<template>
	<div class="news">
		<div class="innerhdon">
			<innerhd />
		</div>
		<div class="innerCon">
			<div class="innerbanner">
				<a href="#"><img :src="newsBanner" /></a>
			</div>
			<div class="bgcolor newsPage">
				<div class="wrapper clearfix">
					<div class="flBlock">
						<titKind :kindlst="kindlst" />
						<div class="whiteBg">
							<div class="newsLst">
								<ul>
									<li v-for="item in newsLst" :key="item.index">
										<!-- <router-link :to="{path:'/Newsdetail',query: {id:item.articleId}}"> -->
											<div class="item clearfix" @click="skipNewsInfo(item)">
												<div class="thumb pic">
													<img :src="item.coverImage" />
												</div>
												<div class="txt">
													<h5>
													<!--<span class="top">置顶</span>
													<span class="hot">热</span>-->
													{{item.title}}
												</h5>
													<p>{{item.description}}</p>
													<span class="readingNum">浏览 {{item.viewCount}} 次</span>
													<span class="time">{{item.crtTime}}</span>
												</div>
											</div>
										<!-- </router-link> -->
									</li>
								</ul>
							</div>
						</div>
						<paging v-if="totalPages>0"  :total='totalPages' @pageing='listArticle' />
					</div>
					<div class="frBlock">
						<div class="wh80"></div>
						<innerFr innerFrtit="热门新闻" :adImg="adImg" :hotNews="hotNews" />
					</div>
				</div>
			</div>
		</div>
		<foot />
		<rightFix />
	</div>
</template>
<script>
import newsBanner from '@/assets/img/newsBanner.jpg'
import innerhd from '@/components/innerHd.vue'
import foot from '@/components/foot.vue'
import rightFix from '@/components/rightFix.vue'
import titKind from '@/components/titKind.vue'
import paging from '@/components/paging.vue'
import innerFr from '@/components/innerFr.vue'
export default {
  name: 'News',
  components: {
    foot,
    rightFix,
    innerhd,
    titKind,
    paging,
    innerFr,
    newsBanner
  },
  data () {
    return {
      newsBanner,
      categoryId: '',
      // kindlst: [],
      newsLst: [],
      queryParams: {
        pageNum: 1,
        pageSize: 5
      },
      totalPages: '',
      adImg: [{
        imgSrc: require('@/assets/img/img7.jpg')
      }, {
        imgSrc: require('@/assets/img/img8.jpg')
      }],
      hotNews: [],
      kindIndex: 0
    }
  },
  computed: {
    kindlst: {
      get: function () {
        let list = this.$store.state.navList
        let newList = []
        let obj = {}
        list.map(item => {
          if (this.categoryId == item.categoryId) {
            obj = item
          } else {
            item.children.map(item1 => {
              if (this.categoryId == item1.categoryId) {
                obj = item1
              } else {
                item1.children.map(item2 => {
                  if (this.categoryId == item2.categoryId) {
                    obj = item2
                  }
                })
              }
            })
          }
        })
        list.map(item => {
          if (obj.pid == item.pid) {
            newList.push(item)
          } else {
            item.children.map(item1 => {
              if (obj.pid == item1.pid) {
                newList.push(item1)
              } else {
                item1.children.map(item2 => {
                  if (obj.pid == item2.pid) {
                    newList.push(item2)
                  }
                })
              }
            })
          }
        })
        newList.map(item => {
          if (item.categoryId == newList[this.kindIndex].categoryId) {
            this.categoryId = newList[this.kindIndex].categoryId
            const categoryId = this.categoryId
            newList[this.kindIndex].selected = true
            this.$set.set(newList[this.kindIndex], 'selected', true)
            this.listArticle()
          } else {
            item.selected = false
          }
        })
        return newList
      },
      set: function (val) {
        this.kindIndex = val
      }
    }
  },
  created () {
    this.categoryId = this.$route.query.categoryId
    this.queryHotList()
  },
  methods: {
    getList (index) {
      this.kindIndex = index
    },
    listArticle (queryParams) {
      const categoryId = this.categoryId
      if (queryParams) {
        this.queryParams.pageNum = queryParams.pageNum
      }
      this.$api.listArticle({ ...this.queryParams, categoryId: this.categoryId }).then(response => {
        this.newsLst = response.rows
        this.totalPages = Math.ceil(response.total / this.queryParams.pageSize)
      })
    },
    getCurrentArticle (current) {
      this.queryParams.pageNum = current
      this.listArticle()
    },
    skipNewsInfo (item) {
      if (item.url !== null && item.isUrl === 'true') {
        window.open(item.url)
      } else {
        this.$router.push({ path: `/Newsdetail/${item.articleId}` })
      }
    },
    getRightBanner () {
      const id = 9
      this.$api.queryAdvertBanner(id).then(response => {
        this.adImg = response.data
      })
    },
    queryHotList () {
      this.$api.HotList().then(response => {
        this.hotNews = response.data
        // console.log(this.hotNews)
      })
    }
  }
}
</script>
<style scoped lang="scss">

</style>
